import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h4", null, "Manage Your Policy", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " To file a claim or manage your policy, visit the website of the appropriate insurer. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { class: "managepolicy-bucket" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("strong", null, "Renters Insurance", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "managepolicy-bucket" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("strong", null, "Accidental Damage Personal Property Coverage", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)

import { links } from "@/utils/Links";

//TODO url read from const file

export default /*#__PURE__*/_defineComponent({
  __name: 'FileAClaimModal',
  setup(__props) {

function openAssurantLink() {
  window.open(links.MY_ASSURANT_POLICY, "_blank");
}

function openNssiLink() {
  window.open(links.CUSTOMER_ACCOUNT_LOGIN, "_blank");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("img", {
        src: require('@/assets/images/managepolicy-assurant.png'),
        style: {"max-width":"340px","width":"'100%'","height":"'auto'"},
        alt: "Manage Policy Assurant"
      }, null, 8, _hoisted_8),
      _hoisted_9,
      _hoisted_10,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openAssurantLink()))
      }, "My Assurant Policy")
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _hoisted_13,
      _createElementVNode("img", {
        src: require('@/assets/images/managepolicy-nssi.png'),
        style: {"max-width":"260px","height":"'auto'"},
        alt: "Manage Policy NSSI"
      }, null, 8, _hoisted_14),
      _hoisted_15,
      _hoisted_16,
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (openNssiLink()))
      }, "NSSI Customer Area")
    ]),
    _hoisted_17
  ], 64))
}
}

})